<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-centered is-mobile">
          <div
            class="column is-5-tablet is-4-desktop is-3-widescreen is-8-mobile"
          >
            <b-image
              :src="require('@/assets/eurotext_logo.png')"
              alt="Eurotext Logo"
            ></b-image>
            <!-- <h3 class="title">Login</h3>
            <div class="is-divider"></div>
            <h2 class="subtitle">{{ $t("login.page.subtitle") }}</h2> -->
            <LoginForm
              :redirection="redirect"
              :loading="getStatus.loggingIn"
              @login="onLogin"
            >
              <template #error>
                <b-notification
                  type="is-danger"
                  aria-close-label="Close notification"
                  role="alert"
                  v-if="getStatus.error"
                >
                  {{ $t("login.error.login_failed") }}
                </b-notification>
              </template>
            </LoginForm>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginForm from "@/components/LoginForm.vue";
export default {
  name: "Login",
  components: { LoginForm },
  data() {
    return {
      redirect: this.$route.query.redirect || "/dashboard",
    };
  },
  computed: {
    ...mapGetters("users", ["getStatus"]),
  },
  // watch: {
  //   getStatus: function(){
  //     if(this.getStatus)
  //   }
  // }
  methods: {
    ...mapActions("users", ["login"]),
    onLogin(username, password) {
      const redirection = this.redirect;
      if (username && password) {
        this.login({ username, password, redirection });
      }
    },
  },
};
</script>

<style></style>
